module.exports = __webpack_public_path__ + "img/stickers_0009_rainbow.ba76cf0f.png";